export const CDN = "/media/";

const STEPS = [500, 750, 1000, 1500];

export const src = (p, w = 1000) => `${CDN}${p.replace("/", `/${w}/`)}`;

export const srcSet = (p, native) =>
  [...STEPS.filter((w) => w < native).map((w) => `${src(p, w)} ${w}w`), `${src(p, 2500)} ${native}w`].join(", ");

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const offset = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
  const target = () => el.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: target(), behavior: reduce ? "auto" : "smooth" });
  setTimeout(() => {
    if (Math.abs(el.getBoundingClientRect().top - offset) > 4) window.scrollTo({ top: target(), behavior: reduce ? "auto" : "smooth" });
  }, 1100);
  window.history.replaceState(null, "", id === "top" ? " " : `#${id}`);
};

export const isOffsite = (href) => /^https?:\/\//.test(href);
